const Reference = () => (
  <>
    <path
      fill="currentColor"
      d="M3 8.25q0-1.767 1.236-3.009Q5.472 4.001 7.23 4q1.357 0 2.43.766a4.24 4.24 0 0 1 1.531 1.967V4.528q0-.213.144-.356a.49.49 0 0 1 .357-.144q.212 0 .356.144a.49.49 0 0 1 .143.356v3.23q0 .344-.232.576a.78.78 0 0 1-.576.232h-3.23a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356a.49.49 0 0 1 .356-.143h2.271a3.16 3.16 0 0 0-1.127-1.842A3.15 3.15 0 0 0 7.253 5q-1.365 0-2.309.947Q4 6.895 4 8.25q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144A.49.49 0 0 1 3 8.25"
    />
    <path
      fill="currentColor"
      d="M19.5 7A2.5 2.5 0 0 0 17 4.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 1 18.5 7v10a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 17v-6a.5.5 0 0 0-1 0v6A2.5 2.5 0 0 0 7 19.5h10a2.5 2.5 0 0 0 2.5-2.5z"
    />
  </>
)
export default Reference
